import { render } from "./prices-rules.template.html?vue&type=template&id=b2c36070&scoped=true"
import script from "./PricesRules.vue?vue&type=script&lang=ts"
export * from "./PricesRules.vue?vue&type=script&lang=ts"

import "./PricesRules.vue?vue&type=style&index=0&id=b2c36070&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b2c36070"

export default script